import { getLoader } from './lib/get-loader';

// Export constants for use in other libraries
export * from './lib/constants';

// Create the global nmp1 object
(globalThis as any).nmp1 = {
  getLoader,
};

declare global {
  interface Window {
    nmp1: {
      getLoader: typeof getLoader;
    };
  }
}

export { getLoader };
